export default __webpack_public_path__ + "static/media/ship.0c6f6473.svg";